import React, { useState } from 'react';
import {
  FaBars,
  FaTwitter,
  FaFacebook,
  FaLinkedin,
  FaGithub,
  FaTimes,
} from 'react-icons/fa';
import '../App.css';
import { useTransition, animated } from 'react-spring';
import { NavLink } from 'react-router-dom';
import { useBlogContext } from '../Context/BlogContext';

const Navs = () => {
  const [menu, setMenu] = useState(false);
  const style = {
    color: 'gray',
    border: '1px solid gray',
    borderRadius: '20px',
    padding: '5px 8px',
  };

  const { authenticated, handleLogout } = useBlogContext();

  const menuContent = (
    <div className='flex blog w-full text-gray-800 flex-col min-h-screen'>
      <FaTimes
        onClick={() => setMenu(false)}
        className='absolute cursor-pointer right-0 text-2xl m-4'
      />

      <h1 className='mt-24 text-center text-3xl font-Poppins'>Welcome</h1>

      <div className='w-full mt-4 space-y-5 '>
        <NavLink
          onClick={() => setMenu(false)}
          className='font-Poppins py-2 text-center block text-sm border-b'
          to='/'
        >
          Home
        </NavLink>

        <NavLink
          onClick={() => setMenu(false)}
          className='font-Poppins py-2 text-center block text-sm border-b'
          to='/manageBlogs'
        >
          Add Post
        </NavLink>

        <NavLink
          onClick={() => setMenu(false)}
          className='font-Poppins py-2 text-center block text-sm border-b'
          to='/about'
        >
          About
        </NavLink>

        {!authenticated ? (
          <NavLink
            onClick={() => setMenu(false)}
            className='font-Poppins py-2 text-center block text-sm border-b'
            to='/login'
          >
            Login
          </NavLink>
        ) : (
          <div className='font-Poppins py-2 text-center block text-sm border-b'>
            <button onClick={handleLogout}>Logout</button>
          </div>
        )}

        {!authenticated && (
          <NavLink
            activeStyle={style}
            className='font-Poppins py-2 text-center block text-sm border-b'
            to='/signup'
          >
            Sign Up
          </NavLink>
        )}
      </div>

      <div className='flex-1 flex justify-center items-center p-6 block w-full space-x-6'>
        <a
          className='transform block hover:scale-110 '
          href='https://github.com/mrWealthid'
        >
          <FaGithub />
        </a>
        <a className='transform block hover:scale-110 ' href='/'>
          <FaTwitter />
        </a>{' '}
        <a className='transform block hover:scale-110 ' href='/'>
          <FaFacebook />
        </a>{' '}
        <a className='transform block hover:scale-110 ' href='/'>
          <FaLinkedin />
        </a>{' '}
      </div>
    </div>
  );

  const transitions = useTransition(menu, {
    from: { opacity: 0, translateX: '-100%' },
    enter: { opacity: 1, translateX: '0%' },
    leave: { opacity: 0, translateX: '-100%' },
  });

  const mystyle = {
    color: 'wheat',
  };

  // const headRef = useRef(null);
  // useEffect(() => {
  // headRef.current.addEventListener('click', (e) => {
  //   console.log('test', e.target);
  //   console.log(e.target.children);

  //   const children = [...e.target.children];

  // if (e.target.classList.contains('nav')) {
  //   console.log('true');
  //   const link = e.target;

  // console.log(e.target);

  // headRef.current.addEventListener('click', (e) => {
  //   console.log('clicked', e.target);

  //   e.target.addEventListener('click', () => {
  //     e.target.textContent = 'fresh';
  //     SetMove((move) => !move);
  //   });
  // });

  // });
  // console.log(children);
  // e.target.style.backgroundColor = 'red';
  // }, []);

  return (
    <div className='header  bg-gray-800 relative'>
      <header className='flex justify-between heads  w-11/12 mx-auto items-center text-white  py-6'>
        <div className=''>
          <p className='text-lg md:text-2xl nav' style={mystyle}>
            Wealth Blog
          </p>
        </div>

        <div className='hidden sm:block space-x-6' style={mystyle}>
          <NavLink
            activeStyle={style}
            className={'text-sm md:text-base'}
            exact
            to='/'
          >
            Home
          </NavLink>
          {authenticated && (
            <NavLink
              activeStyle={style}
              className='text-sm md:text-base nav'
              to='/manageBlogs'
            >
              Add Post
            </NavLink>
          )}
          <NavLink
            activeStyle={style}
            className='text-sm md:text-base nav'
            to='/about'
          >
            About
          </NavLink>

          {authenticated ? (
            <button onClick={handleLogout} className='text-sm md:text-base nav'>
              Logout
            </button>
          ) : (
            <NavLink
              className='text-sm md:text-base nav'
              activeStyle={style}
              to='/login'
            >
              Login
            </NavLink>
          )}

          {!authenticated && (
            <NavLink
              activeStyle={style}
              className='text-sm md:text-base'
              to='/signup'
            >
              Sign Up
            </NavLink>
          )}
        </div>
        <div className='sm:hidden'>
          <FaBars color='wheat' onClick={() => setMenu(!menu)} />
        </div>
        {transitions(
          (styles, item) =>
            item && (
              <animated.div
                style={styles}
                className='Menu sm:hidden flex flex-col w-full min-h-screen space-y-5 items-center absolute left-0 z-50 bg-white top-0 border-black border-r-2'
                onClick={() => setMenu(!menu)}
              >
                {menuContent}
              </animated.div>
            )
        )}
      </header>
    </div>
  );
};

export default Navs;

// import React from "react";
// import { NavLink } from "react-router-dom";

// const Header = () => {
//   const style = {
//     color: "gray",
//     border: "1px solid gray",
//     borderRadius: "20px",
//     padding: "5px 8px",
//   };
//   return (
//     <div className="header bg-gray-800 relative">
//       <header className="flex justify-between  w-11/12 mx-auto items-center text-white  py-6">
//         <div className="">
//           <p className="text-lg md:text-2xl">Wealth Blog</p>
//         </div>
//         <div className="space-x-6">
//           <NavLink
//             activeStyle={style}
//             className="text-sm md:text-base"
//             exact
//             to="/"
//           >
//             Home
//           </NavLink>

//           <NavLink
//             activeStyle={style}
//             className="text-sm md:text-base"
//             to="/manageBlogs"
//           >
//             Add Post
//           </NavLink>

//           <NavLink
//             activeStyle={style}
//             className="text-sm md:text-base"
//             to="/about"
//           >
//             About
//           </NavLink>
//         </div>
//       </header>
//     </div>
//   );
// };

// export default Header;
